import {
  argentinaMKId,
  brazilMKId,
  canadaMKId,
  colombiaMKId,
  mexicoMKId,
  peruMKId,
  spainMKId,
  suiteMKId,
  usMKId,
  russiaMKId,
  ukMKId,
  portugalMKId,
  polandMKId,
  lithuaniaMkId,
  slovakiaMKId,
  moldovaMKId,
  testMKId,
  czechMKId,
  globalMKId, internalMkId,
} from "./StoreConfigManager";

export const storeTrans = {
  [brazilMKId]: {
    //Welcome Message
    heading: "Bem Vinda à",
    title: "Uma experiência de beleza virtual",
    entryText: "Descubra e se encante",
    textBeforeBtn: "da ",

    //Tooltips
    Navega: "NAVEGUE",
    NavegaDes: "Clique e arraste a tela ou use as setas localizadas no chão para explorar.",
    Product: "PRODUTOS",
    productDes: "Clique no ícone para ver os detalhes de cada produto ou para montar a sua lista de desejos.",
    Descub: "DESCUBRA",
    DescubDes: "Clique no ícone para descobrir histórias, curiosidades, inspirações e muito mais.",

    //Product Pop-up
    arrowUp: 'Detalhes acima',
    arrowDown: 'Mais Detalhes',
    removeButtonHeading1: 'Este item foi adicionado',
    removeButtonHeading2: 'à lista de desejos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEJOS",
    removeText: "Remover",
    iconText: "SEÇÕES",
    WishlistHeading: 'Salve seus produtos favoritos em sua lista de desejos para compartilhar com sua Consultora de Beleza Independente Mary Kay',
    heading1: 'Não tem uma Consultora de Beleza?',
    heading2: ' Encontre hoje mesmo uma Consultora',
    heading3: ' de Beleza perfeita para você!',
    shareBtn: 'Compartilhada',

    //Other
    Subject: 'Minha Lista de Encomendas Mary Kay®',
    Message1: 'Olá, acabo de navegar no Suite 13, uma experiência de beleza imersiva e inovadora da Mary Kay®. Esta é a lista de produtos que gostaria de encomendar com você.%0A',
    Message2: '',
    ProductName: 'Produtos',
    ProductPrice: 'Preço',
    currency: 'R$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [argentinaMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubrí la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haga clic y arrastre la pantalla o use flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haga clic en el ícono para ver los detalles del producto u comenzar su lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haga clic en el ícono para explorar historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading1: "Precios en Pesos Argentinos. Los precios son sugeridos a la Fuerza de Ventas Independiente Mary Kay® para la venta a sus propios Clientes y pueden cambiar sin previo aviso.",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes tu propia Consultora?',
    heading2: '¡Contacta a una Consultora',
    heading3: ' y conéctate hoy!',
    shareBtn: 'Compartir',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A',
    ProductName: 'Producto',
    ProductPrice: 'Precio',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [spainMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haz clic y mueve la pantalla o utiliza las flechas del suelo para explorar el espacio.",
    Product: "PRODUCTOS",
    productDes: "Haz clic en el icono para ver los detalles del producto y añadirlo a tu cesta.",
    Descub: "DESCUBRE",
    DescubDes: "Haz clic en el icono para conocer las historias, datos divertidos, inspiración... ¡y mucho más!",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo se ha añadido a la cesta',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Eliminar de la cesta',

    //Sections & Wishlist
    cartText: "CESTA",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes tu propia Consultora?',
    heading2: '¡Contacta con una hoy mismo!',
    heading4: '¿Tienes ya una Consultora de Belleza Mary Kay?',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A ',
    ProductName: 'Producto',
    ProductPrice: 'Precio',
    currency: '€',
    Checkout: "Checkout",
    Yes: "Si",
    No: "No",
    WishlistText: "Envía la lista de tus productos de la cesta a tu Consultor/a de Belleza Independiente.",
    WishlistNoText: "Enviar solicitud de pedido"
  },
  [colombiaMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haz clic y arrastra o utiliza las flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haz clic en el ícono para ver los detalles del producto y para agregarlos en tu lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haz clic en los íconos para descubrir historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes una Consultora de Belleza Independiente?',
    heading2: 'Encuentra una perfecta para ti y contáctala',
    heading3: '',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A ',
    ProductName: 'Producto',
    ProductPrice: 'Precio',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [peruMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haz click y arrastra la plantalla o usa flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haz click en el ícono para ver los detalles del producto o agregarlo a la lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haz click en el ícono para explorar historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Envía la lista de deseos a tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿Aun no tienes Consultora?',
    heading2: 'LOCALIZA A UNA CONSULTORA POR WHATSAPP',
    heading3: '',

    //Other
    Message1: '¡Hola! Acabo de ir de realizar un recorrido por Suite 13, la experiencia virtual de belleza de Mary Kay, ¿puedes brindarme más detalle de los productos en mi lista de deseos? ¡Gracias!%0A',
    Message2: '',
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    ProductName: 'Producto',
    ProductPrice: 'Precio',
    currency: 'S/',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [canadaMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haga clic y arrastre la pantalla o use flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haga clic en el ícono para ver los detalles del producto u comenzar su lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haga clic en el ícono para explorar historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes tu propia Consultora?',
    heading2: '¡Contacta a una Consultora',
    heading3: ' y conéctate hoy!',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A ',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [usMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haga clic y arrastre la pantalla o use flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haga clic en el ícono para ver los detalles del producto u comenzar su lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haga clic en el ícono para explorar historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes tu propia Consultora?',
    heading2: '¡Contacta a una Consultora',
    heading3: ' y conéctate hoy!',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A ',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [suiteMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haga clic y arrastre la pantalla o use flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haga clic en el ícono para ver los detalles del producto u comenzar su lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haga clic en el ícono para explorar historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes tu propia Consultora?',
    heading2: '¡Contacta a una Consultora',
    heading3: ' y conéctate hoy!',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A ',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [mexicoMKId]: {
    //Welcome Message
    heading: "Bienvenido a",
    title: "Una Experiencia de belleza virtual",
    entryText: "Descubre la experiencia",
    textBeforeBtn: "de ",

    //Tooltips
    Navega: "NAVEGA",
    NavegaDes: "Haga clic y arrastre la pantalla o use flechas en el piso para explorar.",
    Product: "PRODUCTOS",
    productDes: "Haga clic en el ícono para ver los detalles del producto u comenzar su lista de deseos.",
    Descub: "DESCUBRE",
    DescubDes: "Haga clic en el ícono para explorar historias, hechos divertidos, inspiración y más.",

    //Product Pop-up
    arrowUp: 'Detalles arriba',
    arrowDown: 'Más Detalles',
    removeButtonHeading1: 'Este artículo ha sido añadido',
    removeButtonHeading2: 'a la lista de deseos',
    removeButtonHeading3: 'Eliminar de lista de deseos',

    //Sections & Wishlist
    cartText: "LISTA DE DESEOS",
    removeText: "Eliminar",
    iconText: "SECCIONES",
    WishlistHeading: 'Guarda tus productos favoritos en tu lista de deseos para compartir con tu Consultora de Belleza Independiente Mary Kay',
    heading1: '¿No tienes tu propia Consultora?',
    heading2: '¡Contacta a una Consultora',
    heading3: ' y conéctate hoy!',
    shareBtn: 'Compartir',
    priceTerms: 'Precios en Pesos Mexicanos e incluyen I.V.A. Precios son sugeridos a la Fuerza de Ventas Independiente Mary Kay® para venta a sus propios Clientes y pueden cambiar sin previo aviso.',

    //Other
    Subject: 'Conoce los Productos Mary Kay® que descubrí ¡y se convirtieron en mis favoritos!',
    Message1: 'Acabo de ir de compras virtualmente en Suite 13 de Mary Kay, una experiencia de belleza inmersiva de otro nivel. Aquí está la lista de mis favoritos. ¡Descúbrela!%0A',
    Message2: '%0A¡Los sueños se hacen realidad! Y conseguir tus productos favoritos también. Adquiérelos a través de una Consultora de Belleza Independiente Mary Kay aquí.%0A ',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [russiaMKId]: {
    //Welcome Message
    heading: "Добро пожаловать в ",
    title: "Виртуальное бьюти-пространство от ",
    entryText: "Откройте новые впечатления",
    textBeforeBtn: "",

    //Tooltips
    Navega: "НАВИГАЦИЯ",
    NavegaDes: "Кликните и перемещайтесь при нажатой кнопке мыши или используйте стрелки на полу, чтобы исследовать пространство",
    Product: "ПРОДУКЦИЯ",
    productDes: "Кликните на значок, чтобы просмотреть сведения о продукте и добавить его в корзину",
    Descub: "ФАКТЫ",
    DescubDes: "Кликните на значок, чтобы ознакомиться с историями, интересными фактами, вдохновляющими цитатами и многим другим.",

    //Product Pop-up
    arrowUp: 'Детали выше',
    arrowDown: 'Подробнее',
    removeButtonHeading1: 'Товар добавлен в корзину!',
    //removeButtonHeading2: 'Этот продукт был удален из корзины.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Удалить из корзины',

    //Sections & Wishlist
    cartText: "КОРЗИНА",
    removeText: "Удалить",
    iconText: "РАЗДЕЛЫ",
    WishlistHeading: 'Поделитесь списком любимой продукции со своим Независимым Консультантом по красоте.',
    heading1: 'У вас нет Независимого Консультанта по красоте? ',
    heading2: 'Найдите Консультанта рядом с вами и свяжитесь с ним удобным для вас способом прямо сейчас.',
    heading3: '',
    //heading4: 'Сделайте заказ понравившейся продукции, если у вас еще нет Независимого Консультанта по красоте.',
    heading4: 'У Вас есть Консультант по красоте Mary Kay?',

    //Other
    Subject: 'Ознакомьтесь со списком моей любимой продукции в Suite 13 от Mary Kay®!',
    Message1: 'Вот список моей любимой продукции, составленный в Suite 13 от Mary Kay®!',
    Message2: '',
    ProductName: 'Средство',
    ProductPrice: 'Цена',
    currency: '₽',
    ConsultantLocatorLink: 'https://www.marykay.ru/ru-ru/find-an-independent-beauty-consultant',
    Message1: "Вот список моей любимой продукции, составленный в Suite 13 от Mary Kay®!",
    wishlistSMSWhatsapp: "Ознакомьтесь со списком моей любимой продукции в Suite 13 от Mary Kay®!",
    portraitViewWarningToolTip: "Рекомендуется просматривать в вертикальном режиме.",
    Checkout: "Заказать",
    Yes: "Да",
    No: "Нет",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [ukMKId]: {
    //Welcome Message
    heading: "Welcome to",
    title: "A Virtual Beauty Experience by",
    entryText: "Discover and enjoy the experience",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigate",
    NavegaDes: "Click and drag or use the arrows on the floor to explore.",
    Product: "Products",
    productDes: "Click on the icon to see the product details and add them to your bag.",
    Descub: "Discover",
    DescubDes: "Click on the icons for fun stories, facts, inspiration and lots more.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Explore Mary Kay® Products and more.",

    //Product Pop-up
    arrowUp: 'Details Above',
    arrowDown: 'More Details',
    removeButtonHeading1: 'This item has been added to your bag!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remove from your bag',

    //Sections & Wishlist
    cartText: "BAG",
    removeText: "Remove",
    iconText: "SECTIONS",
    WishlistHeading: 'Share your favourite products directly with your ',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',

    //Other
    Subject: 'Check out my favourite products from Mary Kay Suite 13!',
    Message1: 'I just went virtually shopping at Mary Kay Suite 13, an immersive beauty experience of another level. A list of my favourite products from my visit to Mary Kay Suite 13.%0A',
    Message2: '%0ADreams come true! And get your favorite products too. Purchase through a Mary Kay Independent Beauty Consultant here.%0A',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '£',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [lithuaniaMkId]: {
    //Welcome Message
    heading: "Sveiki ",
    title: "Virtualiame „Mary Kay“ grožio centre",
    entryText: "Atsipalaiduokite ir išgyvenkite neįtikėtiną nuotykį",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigacija",
    NavegaDes: "Norėdami pasivaikščioti po kambarius, spustelėkite ir pertraukite kompiuterio pelytę arba naudokitės strėlytėmis, kurias rasite yra ant grindų.",
    Product: "Produktai",
    productDes: "Spustelėkite piktogramą ir pažinkite detalią informaciją apie produktus bei įdėkite juos į krepšelį.",
    Descub: "Atraskite",
    DescubDes: "Spustelėkite piktogramas ir skaitykite įdomias istorijas, faktus ir idėjas.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Atraskite tai, kuo „Mary Kay“ yra tokia išskirtinė!",
    exploreProductsMore: "Pažinkite „Mary Kay®“ produktus ir daug daugiau.",

    //Product Pop-up
    arrowUp: 'Detales rasite aukščiau',
    arrowDown: 'Daugiau informacijos',
    removeButtonHeading1: 'Produktas buvo įdėtas į krepšelį!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Pašalinti iš krepšelio',

    //Sections & Wishlist
    cartText: "Krepšelis",
    removeText: "Ištrinti",
    iconText: "„Mary Kay“ zonos",
    WishlistHeading: 'Užsisakykite savo mėgstamiausius produktus tiesiai iš savo Grožio draugės.',
    heading1: `Jūs dar neturite savo „Mary Kay“ grožio konsultantės?`,
    heading2: ' Raskite ją dabar!',
    heading3: '',

    //Other
    Subject: 'Patikrinkite mano mėgstamiausius „Mary Kay® Suite 13“ produktus!',
    Message1: 'Mano mėgstamiausių „Mary Kay® Suite 13“ produktų sąrašas!',
    Message2: '',
    ProductName: 'Produktas',
    ProductPrice: 'Kaina',
    currency: '€',
    Checkout: "Pateikti užsakymą",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов.",
    wishlistSMSWhatsapp: "Patikrinkite mano mėgstamiausius „Mary Kay® Suite 13“ produktus!",
    shareBtn: "Bendrinti"
  },
  [portugalMKId]: {
    //Welcome Message
    heading: "Bem-vinda à",
    title: "Uma Experiência de Beleza Virtual da",
    entryText: "Descubra a experiência",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navegar",
    NavegaDes: "Clique e arraste o ecrã ou use as setas do chão para explorar o espaço.",
    Product: "Produtos",
    productDes: "Clique no ícone para ver os detalhes do produto e adicioná-lo à sua lista de desejos.",
    Descub: "Descobrir",
    DescubDes: "Clique nos ícones para conhecer histórias, dados divertidos, inspiração e muito mais!",
    portraitMode: "Visualize em modo retrato para a melhor experiência.",
    discoverSpecial: "Descubra o que torna a Mary Kay tão especial.",
    exploreProductsMore: "Conheça produtos Mary Kay® e muito mais!",

    //Product Pop-up
    arrowUp: 'Fechar Detalhes',
    arrowDown: 'Mais Detalhes',
    removeButtonHeading1: 'Este produto foi adicionado à sua Lista de Desejos!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remover',

    //Sections & Wishlist
    cartText: "Lista de Desejos",
    removeText: "Remover",
    iconText: "Secções",
    WishlistHeading: 'Partilhe a sua Lista de Desejos com a sua Consultora de Beleza Independente Mary Kay!',
    heading1: `Não tem Consultora de Beleza?`,
    heading2: ' Encontre a sua agora mesmo!',
    heading3: '',
    shareBtn: 'Partilhar',

    //Other
    Subject: 'A minha Lista de Desejos Mary Kay da Suite 13!',
    Message1: 'Esta é a minha mais recente Lista de Desejos de produtos Mary Kay da Suite 13, uma experiência de beleza virtual única! Aqui está ela: %0A',
    Message2: '%0AAcabei de criar a minha Lista de Desejos de produtos Mary Kay na Suite 13, uma experiência de beleza virtual única! Aqui está ela.%0A',
    ProductName: 'Produto',
    ProductPrice: 'Preço',
    currency: '€',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [polandMKId]: {
    //Welcome Message
    heading: "Poznaj",
    title: "Luksusowy Apartament",
    entryText: "Odkrywaj i przeżyj niesamowitą przygodę",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Nawigacja",
    NavegaDes: "Kliknij i przeciągnij lub użyj strzałek umieszczonych na podłodze by przemieszczać się po pokojach",
    Product: "Produkty",
    productDes: "Kliknij na ikonę, by poznać szczegółowe informacje o produktach i dodać je do koszyka",
    Descub: "Odkrywaj",
    DescubDes: "Klikaj na ikony by poznać barwne historie, fakty oraz wyjątkowe inspiracje",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Odkryj co sprawia, że Mary Kay jest tak wyjątkowe!",
    exploreProductsMore: "Poznaj produkty Mary Kay® i wiele więcej",

    //Product Pop-up
    arrowUp: 'Szczegóły powyżej',
    arrowDown: 'Więcej informacji',
    removeButtonHeading1: 'Produkt został dodany do koszyka!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Usuń z koszyka',

    //Sections & Wishlist
    cartText: "Koszyk",
    removeText: "Usuń",
    iconText: "Strefy Mary Kay",
    WishlistHeading: 'Zamawiaj Twoje ulubione produkty bezpośrednio u swojej Przyjaciółki od Piękna.',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',
    heading4: 'Czy masz już swoją Przyjaciółkę od Piękna?',

    //Other
    Subject: 'Sprawdź moje ulubione produkty od Mary Kay Suite 13!',
    Message1: 'Lista moich ulubionych produków od Mary Kay Suite 13!',
    Message2: '',
    ProductName: 'Produkt Name',
    ProductPrice: 'Produkt Cena',
    currency: 'zł',
    Checkout: "Złóż zamówienie",
    Yes: "Tak",
    No: "Nie",
    WishlistText: ""
  },
  [moldovaMKId]: {
    //Welcome Message
    heading: "Bine ai venit în",
    title: "Un spațiu beauty virtual de la",
    entryText: "Descoperă și savurează o experiență nouă",
    textBeforeBtn: "",

    //Tooltips
    Navega: "NAVIGARE",
    NavegaDes: "Fă click și deplasează-te cu butonul mouse-ului apăsat sau folosește săgețile de pe podea pentru a explora spațiul",
    Product: "PRODUSE",
    productDes: "Fă click pe pictogramă pentru a vedea detaliile produsului și pentru a adăuga în coș",
    Descub: "DESCHIDE",
    DescubDes: "Apasă pe pictogramă pentru a afla istorii interesante, citate inspiraționale și multe altele.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Studiază produsele Mary Kay și multe altele.",

    //Product Pop-up
    arrowUp: 'Detaliile sunt mai sus',
    arrowDown: 'Detalii',
    removeButtonHeading1: 'Produsul a fost adăugat în coș!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Șterge din coș',

    //Sections & Wishlist
    cartText: "COȘ",
    removeText: "Șterge  ",
    iconText: "SECȚIUNI",
    WishlistHeading: '',
    heading1: '',
    heading2: '',
    heading3: '',
    shareBtn: 'Distribuie',

    //Other
    Subject: 'Vezi produsele mele preferate în Suite 13 de la Mary Kay!',
    Message1: 'Iată produsele mele preferate în Suite 13 de la Mary Kay!',
    Message2: 'Iată produsele mele preferate în Suite 13 de la Mary Kay!',
    ProductName: 'Produs',
    ProductPrice: 'Preț',
    currency: '£',
    Checkout: "Verifică",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [testMKId]: {
    //Welcome Message
    heading: "Welcome to",
    title: "A Virtual Beauty Experience by",
    entryText: "Discover and enjoy the experience",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigate",
    NavegaDes: "Click and drag or use the arrows on the floor to explore.",
    Product: "Products",
    productDes: "Click on the icon to see the product details and add them to your bag.",
    Descub: "Discover",
    DescubDes: "Click on the icons for fun stories, facts, inspiration and lots more.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Explore Mary Kay® Products and more.",

    //Product Pop-up
    arrowUp: 'Details Above',
    arrowDown: 'More Details',
    removeButtonHeading1: 'This item has been added to your bag!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remove from your bag',

    //Sections & Wishlist
    cartText: "BAG",
    removeText: "Remove",
    iconText: "SECTIONS",
    WishlistHeading: 'Share your favourite products directly with your ',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',

    //Other
    Subject: 'Check out my favourite products from Mary Kay Suite 13!',
    Message1: 'I just went virtually shopping at Mary Kay Suite 13, an immersive beauty experience of another level. A list of my favourite products from my visit to Mary Kay Suite 13.%0A',
    Message2: '%0ADreams come true! And get your favorite products too. Purchase through a Mary Kay Independent Beauty Consultant here.%0A',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '£',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [slovakiaMKId]: {
    //Welcome Message
    heading: "Welcome to",
    title: "A Virtual Beauty Experience by",
    entryText: "Discover and enjoy the experience",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigate",
    NavegaDes: "Click and drag or use the arrows on the floor to explore.",
    Product: "Products",
    productDes: "Click on the icon to see the product details and add them to your bag.",
    Descub: "Discover",
    DescubDes: "Click on the icons for fun stories, facts, inspiration and lots more.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Explore Mary Kay® Products and more.",

    //Product Pop-up
    arrowUp: 'Details Above',
    arrowDown: 'More Details',
    removeButtonHeading1: 'This item has been added to your bag!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remove from your bag',

    //Sections & Wishlist
    cartText: "BAG",
    removeText: "Remove",
    iconText: "SECTIONS",
    WishlistHeading: 'Share your favourite products directly with your ',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',

    //Other
    Subject: 'Check out my favourite products from Mary Kay Suite 13!',
    Message1: 'I just went virtually shopping at Mary Kay Suite 13, an immersive beauty experience of another level. A list of my favourite products from my visit to Mary Kay Suite 13.%0A',
    Message2: '%0ADreams come true! And get your favorite products too. Purchase through a Mary Kay Independent Beauty Consultant here.%0A',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '£',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [czechMKId]: {
    //Welcome Message
    heading: "Welcome to",
    title: "A Virtual Beauty Experience by",
    entryText: "Discover and enjoy the experience",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigate",
    NavegaDes: "Click and drag or use the arrows on the floor to explore.",
    Product: "Products",
    productDes: "Click on the icon to see the product details and add them to your bag.",
    Descub: "Discover",
    DescubDes: "Click on the icons for fun stories, facts, inspiration and lots more.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Explore Mary Kay® Products and more.",

    //Product Pop-up
    arrowUp: 'Details Above',
    arrowDown: 'More Details',
    removeButtonHeading1: 'This item has been added to your bag!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remove from your bag',

    //Sections & Wishlist
    cartText: "BAG",
    removeText: "Remove",
    iconText: "SECTIONS",
    WishlistHeading: 'Share your favourite products directly with your ',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',

    //Other
    Subject: 'Check out my favourite products from Mary Kay Suite 13!',
    Message1: 'I just went virtually shopping at Mary Kay Suite 13, an immersive beauty experience of another level. A list of my favourite products from my visit to Mary Kay Suite 13.%0A',
    Message2: '%0ADreams come true! And get your favorite products too. Purchase through a Mary Kay Independent Beauty Consultant here.%0A',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '£',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },
  [globalMKId]: {
    //Welcome Message
    heading: "Welcome to",
    title: "A Virtual Beauty Experience by",
    entryText: "Discover and enjoy the experience",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigate",
    NavegaDes: "Click and drag or use the arrows on the floor to explore.",
    Product: "Products",
    productDes: "Click on the icon to see the product details and add them to your bag.",
    Descub: "Discover",
    DescubDes: "Click on the icons for fun stories, facts, inspiration and lots more.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Explore Mary Kay® Products and more.",

    //Product Pop-up
    arrowUp: 'Details Above',
    arrowDown: 'More Details',
    removeButtonHeading1: 'This item has been added to your bag!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remove from your bag',

    //Sections & Wishlist
    cartText: "BAG",
    removeText: "Remove",
    iconText: "SECTIONS",
    WishlistHeading: 'Share your favourite products directly with your ',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',

    //Other
    Subject: 'Check out my favourite products from Mary Kay Suite 13!',
    Message1: 'I just went virtually shopping at Mary Kay Suite 13, an immersive beauty experience of another level. A list of my favourite products from my visit to Mary Kay Suite 13.%0A',
    Message2: '%0ADreams come true! And get your favorite products too. Purchase through a Mary Kay Independent Beauty Consultant here.%0A',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '£',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },

  [internalMkId]: {
    //Welcome Message
    heading: "Welcome to",
    title: "A Virtual Beauty Experience by",
    entryText: "Discover and enjoy the experience",
    textBeforeBtn: "",

    //Tooltips
    Navega: "Navigate",
    NavegaDes: "Click and drag or use the arrows on the floor to explore.",
    Product: "Products",
    productDes: "Click on the icon to see the product details and add them to your bag.",
    Descub: "Discover",
    DescubDes: "Click on the icons for fun stories, facts, inspiration and lots more.",
    portraitMode: "View in portrait mode for the best experience.",
    discoverSpecial: "Discover what makes Mary Kay so special.",
    exploreProductsMore: "Explore Mary Kay® Products and more.",

    //Product Pop-up
    arrowUp: 'Details Above',
    arrowDown: 'More Details',
    removeButtonHeading1: 'This item has been added to your bag!',
    // removeButtonHeading2: 'This item has been removed from bag.',
    removeButtonHeading2: '',
    removeButtonHeading3: 'Remove from your bag',

    //Sections & Wishlist
    cartText: "BAG",
    removeText: "Remove",
    iconText: "SECTIONS",
    WishlistHeading: 'Share your favourite products directly with your ',
    heading1: `Don't have your own Consultant?`,
    heading2: 'Contact a Consultant ',
    heading3: 'and connect today!',

    //Other
    Subject: 'Check out my favourite products from Mary Kay Suite 13!',
    Message1: 'I just went virtually shopping at Mary Kay Suite 13, an immersive beauty experience of another level. A list of my favourite products from my visit to Mary Kay Suite 13.%0A',
    Message2: '%0ADreams come true! And get your favorite products too. Purchase through a Mary Kay Independent Beauty Consultant here.%0A',
    ProductName: 'Product Name',
    ProductPrice: 'Product Price',
    currency: '$',
    Checkout: "Checkout",
    Yes: "Yes",
    No: "No",
    WishlistText: "Отправьте список продукции из корзины своему Консультанту одним из предложенных способов."
  },

};
